import { render, staticRenderFns } from "./SectionLayout.vue?vue&type=template&id=141147f6&"
import script from "./SectionLayout.vue?vue&type=script&lang=js&"
export * from "./SectionLayout.vue?vue&type=script&lang=js&"
import style0 from "./SectionLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports